// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AuditLogParentObjectListItem = ({
  resourceName
  , object
}) => {
  return (
    <li key={object._id}>
      <Link to={`/admin/audit-logs/${resourceName}/${object._id}`}>
        {`${resourceName} - ${object.title || object.name || object.description || object.username ||  object.email || object.role || object.text} - ID:${object._id}`}
      </Link>
    </li>
  )
}

AuditLogParentObjectListItem.propTypes = {
  resourceName: PropTypes.string.isRequired
  , object: PropTypes.object.isRequired
}

export default AuditLogParentObjectListItem;


// WEBPACK FOOTER //
// modules/auditLog/components/AuditLogParentObjectListItem.js.jsx